import React from "react";

export default () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.83301 3.33333C2.83301 2.32081 3.65382 1.5 4.66634 1.5H11.333C12.3455 1.5 13.1663 2.32081 13.1663 3.33333V14C13.1663 14.1782 13.0715 14.343 12.9173 14.4325C12.7631 14.5219 12.573 14.5226 12.4183 14.4341L10.333 13.2425L8.24774 14.4341C8.09403 14.522 7.90532 14.522 7.7516 14.4341L5.66634 13.2425L3.58108 14.4341C3.42633 14.5226 3.2362 14.5219 3.08204 14.4325C2.92789 14.343 2.83301 14.1782 2.83301 14V3.33333ZM4.66634 2.5C4.2061 2.5 3.83301 2.8731 3.83301 3.33333V13.1384L5.41827 12.2325C5.57199 12.1447 5.76069 12.1447 5.91441 12.2325L7.99967 13.4241L10.0849 12.2325C10.2387 12.1447 10.4274 12.1447 10.5811 12.2325L12.1663 13.1384V3.33333C12.1663 2.8731 11.7932 2.5 11.333 2.5H4.66634ZM10.7068 5.33333L5.99967 10.0404L5.29257 9.33333L9.99967 4.62623L10.7068 5.33333ZM5.49967 5.66667C5.49967 5.20643 5.87277 4.83333 6.33301 4.83333C6.79325 4.83333 7.16634 5.20643 7.16634 5.66667C7.16634 6.1269 6.79325 6.5 6.33301 6.5C5.87277 6.5 5.49967 6.1269 5.49967 5.66667ZM8.83301 9C8.83301 8.53976 9.2061 8.16667 9.66634 8.16667C10.1266 8.16667 10.4997 8.53976 10.4997 9C10.4997 9.46024 10.1266 9.83333 9.66634 9.83333C9.2061 9.83333 8.83301 9.46024 8.83301 9Z"
      fill="#141414"
    />
  </svg>
);
